<template>
  <div>
    <div class="file-setup" v-if="!isConfiguredPage">
      <div class="configure-box" @click="openConfigured">
        <i class="el-icon-s-tools"></i>
        <span>配置消息存档</span>
      </div>
      <el-form ref="form" :model="form" label-width="140px" class="form">
        <el-form-item label="会话内容存储容量：">
          <div class="bar-box">
            <el-progress :percentage="getCapacityProportion" :stroke-width="10" color="var(--themeColors)"
              :show-text="false" class="progress"></el-progress>
            <div class="content">
              <p class="txt">共：{{capacity.total_space}}MB / 可用：{{(capacity.total_space -
                              capacity.session_space).toFixed(2)}}MB</p>
              <p class="txt" style="color: var(--themeColors);cursor: pointer" @click="addCapacity">增加容量</p>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="会话内容清理操作：">
          <el-button class="clean-btn" @click="openClean">手动清理内容</el-button>
        </el-form-item>
        <el-form-item label="会话内容存储管理：">
          <el-table id="table" :data="config" :header-cell-style="{background:'rgb(249,249,249)'}" ref="multipleTable"
            :row-style="{height: '40px'}" style="width: 100%;margin: 0 auto">
            <el-table-column align="left" prop="type" label="存储类型">
              <template v-slot="scope">
                <p v-if="scope.row.type === 1">视频<span class="format">.mp4 .mov</span></p>
                <p v-if="scope.row.type === 2">图片<span class="format">.jpg .png .bmp .gif</span></p>
                <p v-if="scope.row.type === 3">文档<span class="format">.doc .docx .pdf</span></p>
                <p v-if="scope.row.type === 4">表格<span class="format">.xls .xlsx</span></p>
                <p v-if="scope.row.type === 5">演示文档<span class="format">.ppt .pptx</span></p>
                <p v-if="scope.row.type === 6">压缩包<span class="format">.zip .rar .7z</span></p>
                <p v-if="scope.row.type === 7">语音音频<span class="format">.mov .mp4 .wav</span></p>
                <p v-if="scope.row.type === 8">其他</p>
              </template>
            </el-table-column>
            <el-table-column prop="state" align="center" label="存储策略">
              <template v-slot="scope">
                <span v-if="scope.row.state === 0">不存储</span>
                <span v-else-if="scope.row.state === 1">存储</span>
              </template>
            </el-table-column>
            <el-table-column prop="filesize" align="center" label="文件大小">
              <template v-slot="scope">
                <span v-if="scope.row.filesize === ''">不限制</span>
                <span
                  v-else-if="JSON.parse(scope.row.filesize).length === 2">{{JSON.parse(scope.row.filesize)[0]}}M~{{JSON.parse(scope.row.filesize)[1]}}M</span>
              </template>
            </el-table-column>
            <el-table-column prop="visit_time" label="操作" align="center">
              <template v-slot="scope">
                <span class="btn"
                  @click="open_edit_storage(scope.row.id, scope.row.type, scope.row.state, scope.row.filesize)">编辑</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>


      <Dialog :show.sync="edit_storage_show" :name_width="edit_storage" class="edit_storage">
        <span slot="body">
          <el-form ref="edit_form" :model="edit_form" label-width="100px" class="edit_form">
            <el-form-item label="存储类型：">
              <el-select v-model="edit_form.type" placeholder="请选择" class="input_w300" disabled>
                <el-option v-for="(item, index) in data" :key="index+1" :label="item.name" :value="index+1">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="存储策略：">
              <el-select v-model="edit_form.state" placeholder="请选择" class="input_w300">
                <el-option :key="0" label="不存储" :value="0">不存储</el-option>
                <el-option :key="1" label="存储" :value="1">存储</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="文件大小：" v-if="edit_form.state === 1">
              <div class="box">
                <el-input type="number" v-model="edit_form.size1" class="input_w80"></el-input> MB ~
                <el-input type="number" v-model="edit_form.size2" class="input_w80"></el-input> MB
                <span class="tips">文件大小在此之间的保存，其他内容不保存</span>
              </div>
            </el-form-item>
          </el-form>
        </span>
        <div slot="footer">
          <el-button type="primary" @click="save_edit_storage">保 存</el-button>
          <el-button @click="edit_storage_show = false">取 消</el-button>
        </div>
      </Dialog>

      <Dialog :show.sync="clean_show" :name_width="clean_dialog" class="clean_dialog">
        <span slot="body">
          <div class="top-box">
            <span>
              <svg t="1627353665062" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                p-id="2410" width="24" height="24">
                <path
                  d="M510.976694 146.304134c-201.970968 0-365.695866 163.728992-365.695866 365.695866s163.728992 365.695866 365.695866 365.695866 365.695866-163.728992 365.695866-365.695866S712.947661 146.304134 510.976694 146.304134L510.976694 146.304134zM480.489332 329.151555c0-16.82827 13.631462-30.475082 30.475082-30.475082 16.844643 0 30.472012 13.646811 30.472012 30.475082l0 216.70146c0 16.82827-13.627369 30.475082-30.472012 30.475082-16.84362 0-30.475082-13.646811-30.475082-30.475082L480.489332 329.151555 480.489332 329.151555zM510.976694 694.847421c-23.663956 0-42.846854-19.178805-42.846854-42.842761s19.182898-42.846854 42.846854-42.846854c23.663956 0 42.846854 19.182898 42.846854 42.846854C553.823548 675.664523 534.64065 694.847421 510.976694 694.847421L510.976694 694.847421zM510.976694 694.847421"
                  p-id="2411" fill="#f0ac04"></path>
              </svg>
            </span>
            <span class="txt">清理内容不能恢复，请谨慎操作</span>
          </div>
          <el-form ref="edit_form" :model="clean_form" label-width="100px" class="clean_form">
            <el-form-item label="清理范围：">
              <el-button class="clean-btn" @click="member_show = true">选择清理范围</el-button>
              <!-- <span class="estimate">预计清除 1111M 存储空间</span> -->
            </el-form-item>
            <el-form-item label="清理时间：">
              <el-date-picker v-model="clean_form.time" type="date" value-format="timestamp" placeholder="选择日期">
              </el-date-picker>
              <span class="tips" style="margin-left: 10px;">此之前的内容全部删除</span>
            </el-form-item>
          </el-form>
        </span>
        <div slot="footer">
          <el-button type="primary" @click="getSpace">确 认</el-button>
          <el-button @click="clean_show = false">取 消</el-button>
        </div>
      </Dialog>

      <Dialog :show.sync="member_show" :name_width="member_dialog" class="member_dialog">
        <span slot="body">
          <div class="box">
            <div class="member-box">
              <div class="top">
                <p class="title">成员（{{this.member_list.length}}）</p>
                <el-input v-model="searchName" @keyup.enter.native="searchMember" placeholder="搜索成员"
                  style="width: 180px;margin-top: 5px;"></el-input>
              </div>
              <div class="member-list">
                <div class="list" :class="{select: thisMemberUserId == value.userid}" :key="index"
                  v-for="(value, index) in member_list" @click="getFriendsList(value.userid, value.name)">
                  <div class="head">
                    <img :src="value.head_image" alt="">
                  </div>
                  <div class="info">
                    <p class="name">{{value.name}}</p>
                    <p class="bm">{{value.department[0].name}}</p>
                  </div>
                  <el-checkbox class="checked" v-model="value.checked"></el-checkbox>
                </div>
              </div>
            </div>
            <div class="chat-box">
              <div class="top">
                <p class="title">{{thisMemberName != '' ? thisMemberName : '联系人'}}</p>
                <el-input v-model="lxrName" @keyup.enter.native="searchMember1" placeholder="搜索外部联系人"
                  style="width: 180px;margin-top: 5px;"></el-input>
              </div>
              <el-tabs v-model="activeName" class="lxr-list">
                <el-tab-pane label="内部联系人" name="first">
                  <div class="lxr-list">
                    <div class="list" :key="index" v-for="(value, index) in QwUserList">
                      <div class="head">
                        <img :src="value.avatar" alt="">
                      </div>
                      <div class="info">
                        <p class="name">{{value.name}}</p>
                        <!-- <p class="xx">设计部</p> -->
                      </div>
                      <div class="right">
                        <span class="time">{{value.sessionarchive ? value.sessionarchive.msgtime : '' |
                                                  getTimeText}}</span>
                        <el-checkbox class="checked" v-model="value.checked"></el-checkbox>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="外部联系人" name="second">
                  <div class="lxr-list">
                    <div class="list" :key="index" v-for="(value, index) in ExternalUserList.list">
                      <div class="head">
                        <img :src="value.external_contact.avatar" alt="">
                      </div>
                      <div class="info">
                        <p class="name">{{value.external_contact.name}}</p>
                        <!-- <p class="xx">设计部</p> -->
                      </div>
                      <div class="right">
                        <span class="time">{{value.sessionarchive ? value.sessionarchive.msgtime : '' |
                                                  getTimeText}}</span>
                        <el-checkbox class="checked" v-model="value.checked"></el-checkbox>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="群聊" name="third">
                  <div class="lxr-list">
                    <div class="list" :key="index" v-for="(value, index) in group_list.list">
                      <!-- <div class="head">
                        <img :src="value.external_contact.avatar" alt="">
                      </div> -->
                      <div class="info">
                        <p class="name">{{value.chat_name}}</p>
                        <!-- <p class="xx">设计部</p> -->
                      </div>
                      <div class="right">
                        <span class="time">{{value.session_archive ? value.session_archive.msgtime : '' |
                                                  getTimeText}}</span>
                        <el-checkbox class="checked" v-model="value.checked"></el-checkbox>
                      </div>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </span>
        <div slot="footer">
          <el-button type="primary" @click="confirmMember">确 认</el-button>
          <el-button @click="member_show = false">取 消</el-button>
        </div>
      </Dialog>

      <Dialog :show.sync="clean_box_show" :name_width="clean_box_dialog" class="clean_box_dialog">
        <span slot="body">
          <div class="box" v-if="cleanDialogType === 1">
            <p>
              <svg t="1627356351277" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                p-id="2843" width="100" height="100">
                <path
                  d="M952.647417 752.812601l-393.812227-622.344131c-9.768481-15.639189-27.816532-25.363667-47.003524-25.363667-19.230993 0-37.235043 9.724479-47.046502 25.363667L70.962703 752.812601c-10.425444 16.647145-10.272971 37.232996 0.394996 53.703109 10.031471 15.507182 27.464515 24.750707 46.630017 24.750707l787.6572 0c19.184945 0 36.621059-9.242502 46.608527-24.750707C962.941877 790.045597 963.072861 769.459746 952.647417 752.812601zM575.913147 767.399831l-128.169101-0.084934 0.008186-127.316687 128.033002 0.085958L575.913147 767.399831zM447.871959 576.117296l-0.404206-255.987209 127.635959 0-0.341784 256.167311L447.871959 576.117296z"
                  p-id="2844" fill="#e98f36"></path>
              </svg>
            </p>
            <div class="text-box">
              <p>会话消息内容清理</p>
              <p style="color: var(--themeColors)">共计清除 {{this.session_space}}M 存储容量</p>
            </div>
          </div>
          <div class="box1" style="" v-if="cleanDialogType === 2">
            <el-progress :percentage="getDelProportion" :stroke-width="10" color="var(--themeColors)"
              class="progress"></el-progress>

            <p class="jd">会话存档 <span class="blue">正在清理</span></p>
          </div>
          <div class="box" v-if="cleanDialogType === 3">
            <p>
              <svg t="1627358137176" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                p-id="4063" width="100" height="100">
                <path
                  d="M512 85.333333c235.648 0 426.666667 191.018667 426.666667 426.666667s-191.018667 426.666667-426.666667 426.666667S85.333333 747.648 85.333333 512 276.352 85.333333 512 85.333333z m-74.965333 550.4L346.453333 545.152a42.666667 42.666667 0 1 0-60.330666 60.330667l120.704 120.704a42.666667 42.666667 0 0 0 60.330666 0l301.653334-301.696a42.666667 42.666667 0 1 0-60.288-60.330667l-271.530667 271.488z"
                  fill="#2aa515" p-id="4064"></path>
              </svg>
            </p>
            <div class="text-box">
              <p>会话消息内容清理成功</p>
              <p style="color: var(--themeColors)">共计清除 {{this.session_space}}M 存储容量</p>
            </div>
          </div>

        </span>
        <div slot="footer">
          <el-button type="primary" @click="confirmDel">确 认</el-button>
          <el-button @click="clean_box_show = false">取 消</el-button>
        </div>
      </Dialog>
    </div>

    <div class="configured-setup" v-else>
      <div class="box">
        <p class="title">1、进入企业微信</p>
        <p class="tips-p">
          进入<span class="blue-txt">企业微信</span>，打开<span class="bold-txt">【管理工具】</span>，选择<span
            class="bold-txt">【会话内容存档】</span>
        </p>
        <img class="img" src="~assets/img/messages_messages-config-1.jpg" alt="">
      </div>

      <div class="box">
        <p class="title">2、按照以下教程进行设置</p>
        <p class="tips-p">
          (1)选择<span class="bold-txt">【开启范围】</span>
        </p>
        <p class="tips-p1">在<span class="bold-txt">【开启范围】</span>添加成员，即可以获取该成员的会话内容，这里的成员一定要是<span
            class="red-txt">【确认授权给获客通助手应用的成员】</span>，否则无法使用。</p>
        <img class="img" src="~assets/img/messages_messages-config-2.jpg" alt="">
        <p class="tips-p">
          (2)添加<span class="bold-txt">【可信IP地址】</span>到企业微信
        </p>
        <p class="tips-p1">将一下内容添加到企业微信<span class="bold-txt">【可信IP地址】</span></p>
        <div class="copy-box">
          <div class="text-box">47.115.162.28</div>
          <span class="copy-btn copyip" data-clipboard-text="47.115.162.28" @click="copyIp">复制</span>
        </div>
        <img class="img" src="~assets/img/messages_messages-config-3.jpg" alt="">
        <p class="tips-p">
          (3)添加<span class="bold-txt">【消息加密公钥】</span>
        </p>
        <p class="tips-p1">将以下内容添加到企业微信<span class="bold-txt">【消息加密公钥】</span></p>
        <div class="copy-box">
          <div class="text-box">
            {{configInfo.public_key}}
          </div>
          <span class="copy-btn copy-key" :data-clipboard-text="configInfo.public_key" @click="copyKey">复制</span>
        </div>
        <p class="tips-p">
          (4)复制<span class="bold-txt">【Secret】</span>内容
        </p>
        <p class="tips-p1">请在企业微信复制<span class="bold-txt">会话内容存档【Secret】</span>内容，一会儿会用到，需要填到文末表格内提交给我们</p>
        <img class="img" src="~assets/img/messages_messages-config-4.jpg" alt="">
        <p class="tips-p">
          (5)功能禁用解释
        </p>
        <p class="tips-p1">消息存档功能无法获取语音/视频通话记录和文件传输助手内容，你可以选择禁用相关功能</p>
        <p class="warning">注意：禁用后该账号不可使用语音/视频通话和文件传输助手功能</p>
        <img class="img" src="~assets/img/messages_messages-config-5.jpg" alt="">
        <p class="tips-p">
          (6) 服务须知
        </p>
        <p class="tips-p1">成员与外部联系人聊天时，将向外部联系人发送服务须知，告知企业会存档会话内容。外部联系人<span class="bold-txt">【默认同意保存会话内容】</span>，可选择更改为不同意
        </p>
        <img class="img" src="~assets/img/messages_messages-config-6.jpg" alt="">
      </div>
      <div class="box">
        <p class="title">3、提交信息给微伴</p>
        <p class="tips-p1">请找到以下一条信息填写到下方表格中提交，即可使用消息存档功能</p>
        <p class="tips-p">
          (1) 将上文中提到的<span class="bold-txt">【会话内容存档Secret】</span>填到下方表格
        </p>
        <img class="img" src="~assets/img/messages_messages-config-7.jpg" alt="">
      </div>
      <div class="box">
        <p class="title">提交设置</p>
        <p class="tips-p">
          (1) 填写上述信息至表格中
        </p>
        <div class="input-box">
          <span>会话内容存档Secret：</span>
          <el-input v-model="configInfo.session_secret" class="input_w500" placeholder="请输入会话内容存档Secret"></el-input>
        </div>
      </div>
      <el-button class="submit" @click="submit">提交</el-button>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard'

import Dialog from "components/content/dialog/Dialog";
import {getQwMember} from 'network/hk_wechat'
import {getSessionArchiveConfig, editSessionArchiveConfig, getQwExternalUserList, getQwUserList, getQwChatList, delSessionArchive, getDelSessionArchiveSpace, createKey, editQwSessionArchiveConfig} from "network/hk_session_archiving"
import {
		retujudpower,
		retupower,
		alertMess,
	} from '@src/network/kh_public'
export default {
  name: "FileSetup",
  components: {
    Dialog
  },
  data() {
    return {
		is_powerAdd: false,
		is_powerEdit: false,
		is_powerDel: false,
		is_powerImp: false,
		is_powerExp: false,
		is_powerRec: false,
      // 编辑存储类型
      edit_storage: {
        name: '编辑存储类型',
        width: '650px'
      },
      edit_storage_show: false,
      // 手动清理内容
      clean_dialog: {
        name: '手动清理内容',
        width: '650px'
      },
      clean_show: false,
      // 手动清理内容 选择范围
      member_dialog: {
        name: '手动清理内容 选择范围',
        width: '650px'
      },
      member_show: false,

      // 清理内容弹窗
      clean_box_dialog: {
        name: '清理警告',
        width: '650px'
      },
      clean_box_show: false,


      // 容量
      capacity: {
        total_space: 2000,
        session_space: 0,
      },
      // 配置信息
      config: [],
      data: [
        {type: 1, name: '视频'},
        {type: 2, name: '图片'},
        {type: 3, name: '文档'},
        {type: 4, name: '表格'},
        {type: 5, name: '演示文档'},
        {type: 6, name: '压缩包'},
        {type: 7, name: '语音音频'},
        {type: 8, name: '其他'},
      ],

      form: {
        name: '',
      },

      edit_form: {
        id: null,
        type: 0,
        state: 1,
        filesize: [],
        size1: 0,
        size2: 0
      },
      clean_form: {
        time: '',
      },
      searchName: '',
      lxrName: '',

      member_select: {
        checked: false
      },

      activeName: 'first',

      cleanDialogType: 1,


      // 删除记录
      // 成员列表
      member_list: [],
      member_list1: [],
      // 当前选择的成员userid  name
      thisMemberUserId: '',
      thisMemberName: '成员',

      // 内部联系人列表
      QwUserList: [],
      QwUserList1: [],
      delQwUser: {
        pagesize: 20,
        page: 1,
        list: []
      },

      // 外部联系人列表
      ExternalUserList: {
        limit: 20,
        cursor: 1,
        list: []
      },
      ExternalUserList1: {
        limit: 20,
        cursor: 1,
        list: []
      },

      group_list: {
        pagesize: 20,
        page: 1,
        list: []
      },
      group_list1: {
        pagesize: 20,
        page: 1,
        list: []
      },
      group_list2: {
        pagesize: 20,
        page: 1,
        list: []
      },
      // 需要清除的信息
      nodel_info: [],
      // 需要删除的记录容量
      session_space: 0,
      // 总数
      session_count: 0,
      // 正在删除的数
      delIngCount: 0,

      // 是否为配置设置页
      isConfiguredPage: false,
      configInfo: {
        session_secret: '',
        public_key: '',
        private_key: ''
      }

      
    }
  },
  watch: {
    cleanDialogType() {
      if (this.cleanDialogType === 2) {
        let doc = document.getElementsByClassName('clean_box_dialog')[0].children[0].children[0].children[2]
        doc.style.display = 'none'
      } else if (this.cleanDialogType === 3) {
        let doc = document.getElementsByClassName('clean_box_dialog')[0].children[0].children[0].children[2]
        console.log(doc)
        doc.style.display = 'block'
      }
    }
  },
  filters: {
    // 计算日期
    getTimeText(time) {
      if (time == '') {
        return ''
      } else {
        let date = new Date(time*1000);
        let YY = date.getFullYear() + '/';
        let MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/';
        let DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
        let hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
        let mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
        let ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
        return YY + MM + DD
      }
    }
  },
  computed: {
    getCapacityProportion() {
      return (this.capacity.session_space / this.capacity.total_space) * 100
    },
    getDelProportion() {
      return Math.round(this.delIngCount / this.session_count * 100) 
    }
  },
  created() {
    if (this.$route.query.isConfig) {
      this.isConfiguredPage = true
    }
    this.getSessionArchiveConfig()
    this.createKey()
	this.judgePower()
  },
  methods: {
	  judgePower() {
	  	this.is_powerAdd = retupower('142')
	  	this.is_powerEdit = retupower('143')
	  	this.is_powerDel = retupower('144')
	  	this.is_powerImp = retupower('145')
	  	this.is_powerExp = retupower('146')
	  	this.is_powerRec = retupower('147')
	  },
    addCapacity() {
      this.$message({
        message: '暂不支持自行扩容，请联系服务商',
        type: 'warning',
        offset: 100
      });
    },

    // 编辑存储类型
    open_edit_storage(id, type, state, filesize) {
		if(retujudpower(this.is_powerEdit)) {
			this.edit_form.id = id
			this.edit_form.type = type
			this.edit_form.state = state
			if (state === 1) {
			  this.edit_form.size1 = JSON.parse(filesize)[0]
			  this.edit_form.size2 = JSON.parse(filesize)[1]    
			}
			
			this.edit_storage_show = true
		}
     
    },
    save_edit_storage() {
      if (this.edit_form.state === 1) {
        let filesize = []
        filesize.push(this.edit_form.size1,this.edit_form.size2)
        this.editSessionArchiveConfig(this.edit_form.id, this.edit_form.state, JSON.stringify(filesize))
      } else if (state === 0) {
        this.editSessionArchiveConfig(this.edit_form.id, this.edit_form.state)
      }
    },
    // 打开手动清除内容弹窗
    openClean() {
		if(retujudpower(this.is_powerEdit)) {
			this.getQwMember()
			
			this.clean_show = true
		}
     
    },

    // 确认选择删除的成员记录
    confirmMember() {
      this.nodel_info= []

      this.member_list.map((value) => {
        if (value.checked) {
          this.nodel_info.push({fromid: value.userid})
        }
      })
      
      this.member_show = false
    },
    // 获取需要删除的空间
    getSpace() {
      this.getDelSessionArchiveSpace(JSON.stringify(this.nodel_info), this.clean_form.time/1000)
      this.clean_box_show = true
    },

    // 确认删除内容
    confirmDel() {
      if (this.cleanDialogType === 1) {
        this.cleanDialogType = 2
        this.delSessionArchive(JSON.stringify(this.nodel_info), this.clean_form.time/1000, 10)
      } else if (this.cleanDialogType === 3) {
        this.clean_box_show = false
        this.clean_show = false
      }
    },


    // 点击成员获取好友群聊列表
    getFriendsList(userid, name) {
      this.thisMemberUserId = userid
      this.thisMemberName = name
      this.getQwUserList(userid)
      this.getQwExternalUserList(userid, '', this.ExternalUserList.limit)
      this.getQwChatList(userid, this.group_list.pagesize, this.group_list.page, 0)
      this.getQwChatList(userid, this.group_list1.pagesize, this.group_list1.page, 1)
    },

    searchMember() {
      if (this.searchName == '') {
        this.getQwMember()
      } else {
        let list = []
        let reg = new RegExp(this.searchName)
        this.member_list1.map((value) => {
        if (reg.test(value.name)) {
          list.push(value)
        }
      })
      this.member_list = list
      }
    },
    searchMember1() {
      if (this.activeName == 'first') {
        if (this.lxrName == '') {
          this.getQwUserList(this.thisMemberUserId)
        } else {
          let list = []
          let reg = new RegExp(this.lxrName)
          this.QwUserList1.map((value) => {
            if (reg.test(value.name)) {
              list.push(value)
            }
          })
          this.QwUserList = list
        }
      } else if (this.activeName == 'second') {
        if (this.lxrName == '') {
          this.getQwExternalUserList(this.thisMemberUserId, '', this.ExternalUserList.limit)
        } else {
          let list = []
          let reg = new RegExp(this.lxrName)
          this.ExternalUserList1.list.map((value) => {
            if (reg.test(value.external_contact.name)) {
              list.push(value)
            }
          })
          this.ExternalUserList.list = list
        }
      } else if (this.activeName == 'third') {
        if (this.lxrName == '') {
          this.getQwChatList(this.thisMemberUserId, this.group_list.pagesize, this.group_list.page, 0, '')
        } else {
          this.getQwChatList(this.thisMemberUserId, this.group_list.pagesize, this.group_list.page, 0, this.lxrName)
        }
      }
    },

    openConfigured() {
		if(retujudpower(this.is_powerEdit)) {
			this.isConfiguredPage = true
			
		}
    },
    copyIp() {
      let clipboard = new Clipboard('.copyip')
      clipboard.on('success', e => {
        this.$message({
          message: '复制成功',
          type: 'success',
          offset: 100
        });
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        this.$message({
          message: '该浏览器不支持自动复制',
          type: 'error',
          offset: 100
        });
        clipboard.destroy()
      })
    },
    copyKey() {
      let clipboard = new Clipboard('.copy-key')
      clipboard.on('success', e => {
        this.$message({
          message: '复制成功',
          type: 'success',
          offset: 100
        });
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        this.$message({
          message: '该浏览器不支持自动复制',
          type: 'error',
          offset: 100
        });
        clipboard.destroy()
      })
    },

    submit() {
      if (this.configInfo.session_secret == '') {
        this.$message({
          message: '请填写会话内容存档Secret后再提交！',
          type: 'warning',
          offset: 100
        })
      } else {
        let fd = new FormData()
        fd.append('session_secret', this.configInfo.session_secret)
        fd.append('publickey', this.configInfo.public_key)
        fd.append('privatekey', this.configInfo.private_key)
        this.editQwSessionArchiveConfig(fd)
      }
      
    },



     // 会话存档配置
    getSessionArchiveConfig() {
      getSessionArchiveConfig().then(res => {
        if (res.code === 10000) {
          this.capacity.total_space = res.result.total_space
          this.capacity.session_space = res.result.session_space
          this.config = res.result.config
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            offset: 100
          })
        }
      })
    },

     // 编辑会话存档配置
    editSessionArchiveConfig(id, state, filesize) {
      editSessionArchiveConfig(id, state, filesize).then(res => {
        if (res.code === 10000) {
          this.$message({
            message: '保存成功',
            type: 'success',
            offset: 100
          })
          this.getSessionArchiveConfig()
          this.edit_storage_show = false
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            offset: 100
          })
        }
      })
    },

    //  成员列表
    getQwMember() {
      getQwMember().then(res => {
        if (res.code === 10000) {
          this.member_list = res.result
          this.member_list.map((value) => {
            this.$set(value,'checked', true);
          })
          this.member_list1 = res.result
          this.member_list1.map((value) => {
            this.$set(value,'checked', true);
          })
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            offset: 100
          })
        }
      })
    },
    //  内部联系人列表
    getQwUserList(userid) {
      getQwUserList(userid).then(res => {
        if (res.code === 10000) {
          this.QwUserList = res.result
          this.QwUserList.map((value) => {
            this.$set(value,'checked', true);
          })
          this.QwUserList1 = res.result
          this.QwUserList1.map((value) => {
            this.$set(value,'checked', true);
          })
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            offset: 100
          })
        }
      })
    },
    //  外部联系人列表
    getQwExternalUserList(userid, cursor, limit) {
      getQwExternalUserList(userid, cursor, limit).then(res => {
        if (res.code === 10000) {
          this.ExternalUserList.list = res.result.external_contact_list
          this.ExternalUserList.list.map((value) => {
            this.$set(value,'checked', true);
          })
          this.ExternalUserList1.list = res.result.external_contact_list
          this.ExternalUserList1.list.map((value) => {
            this.$set(value,'checked', true);
          })
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            offset: 100
          })
        }
      })
    },
    //  群聊列表
    getQwChatList(userid, pagesize, page, is_lock, chat_name) {
      getQwChatList(userid, pagesize, page, is_lock, chat_name).then(res => {
        if (res.code === 10000) {
          if (is_lock == 0) {
            this.group_list.list = res.result.data
            this.group_list.list.map((value) => {
              this.$set(value,'checked', true);
            })
            this.group_list2.list = res.result.data
            this.group_list2.list.map((value) => {
              this.$set(value,'checked', true);
            })
          } else if (is_lock == 1) {
            this.group_list1.list = res.result.data
            this.group_list1.list.map((value) => {
              this.$set(value,'checked', true);
            })
          }
          
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            offset: 100
          })
        }
      })
    },
    //  删除记录
    delSessionArchive(nodel_info, msgtime, pagesize) {
      delSessionArchive(nodel_info, msgtime, pagesize).then(res => {
        if (res.code === 10000) {
          if (res.result === 1) {
            this.delIngCount += 10
            this.delSessionArchive(JSON.stringify(this.nodel_info), this.clean_form.time/1000, 10)
          } else if (res.result === 0) {
            this.cleanDialogType = 3
          }
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            offset: 100
          })
        }
      })
    },
    //  删除记录的信息
    getDelSessionArchiveSpace(nodel_info, msgtime) {
      getDelSessionArchiveSpace(nodel_info, msgtime).then(res => {
        if (res.code === 10000) {
          this.session_space = res.result.session_space
          this.session_count = res.result.session_count
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            offset: 100
          })
        }
      })
    },

    // 获取公私密钥
    createKey() {
      createKey().then(res => {
        if (res.code === 10000) {
          this.configInfo.public_key = res.result.public_key
          this.configInfo.private_key = res.result.private_key
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            offset: 100
          })
        }
      })
    },

    // 配置会话存档
    editQwSessionArchiveConfig(data) {
      editQwSessionArchiveConfig(data).then(res => {
        if (res.code === 10000) {
          this.$message({
            message: '提交成功',
            type: 'success',
            offset: 100
          })
          this.isConfiguredPage = false
        } else {
          this.$message({
            message: res.message,
            type: 'error',
            offset: 100
          })
        }
      })
    },
  }
}
</script>

<style scoped>
.file-setup {
  padding: 40px 30px;
  background: #fff;
  margin-top: 10px;
  position: relative;
}

.file-setup .configure-box {
  position: absolute;
  top: 45px;
  right: 40px;
  cursor: pointer;
  z-index: 10;
}

.file-setup .configure-box>span {
  color: var(--themeColors);
}

.file-setup .form .bar-box {
  display: flex;
  align-items: center;
}

.file-setup .form .bar-box .progress {
  width: 310px;
}

.file-setup .form .bar-box .content {
  margin-left: 10px;
  display: flex;
}

.file-setup .form .bar-box .content .txt {
  font-size: 14px;
  margin-right: 10px;
}

.file-setup .form .clean-btn {
  background: var(--themeColors);
  border: none;
  padding: 9px 15px;
  color: #fff;
}

.file-setup .form .clean-btn:hover {
  background: var(--themeColorsHover);
}

#table .format {
  font-size: 12px;
  color: #888;
  margin-left: 10px;
}

#table .btn {
  color: var(--themeColors);
  cursor: pointer;
}

.edit_storage .input_w300 {
  width: 300px;
}

.edit_storage .input_w80 {
  width: 80px;
}

.clean_dialog .top-box {
  border: 1px solid rgb(255, 194, 103);
  background: rgb(255, 246, 233);
  padding: 10px;
  display: flex;
  align-items: center;
}

.clean_dialog .top-box .txt {
  margin-left: 10px;
}

.clean_dialog .clean_form {
  margin-top: 20px;
}

.clean_dialog .clean-btn {
  background: var(--themeColors);
  border: none;
  padding: 9px 15px;
  color: #fff;
}

.clean_dialog .clean-btn:hover {
  background: var(--themeColorsHover);
}

.clean_dialog .estimate {
  color: rgb(255, 141, 26);
  margin-left: 10px;
}

.member_dialog .box {
  width: 100%;
  height: 370px;
  display: flex;
}

.member_dialog .box .member-box {
  width: 220px;
  border: 1px solid rgb(229, 229, 229);
}

.member_dialog .box .member-box .top {
  width: 100%;
  padding: 10px;
  background: rgb(217, 235, 255);
  box-sizing: border-box;
}

.member_dialog .box .member-box .top .title {
  font-weight: bold;
  color: rgb(56, 56, 56);
}

.member_dialog .box .member-box .member-list {
  padding-top: 10px;
  width: 100%;
  overflow: hidden;
  overflow-y: auto;
  height: 280px;
}

.member_dialog .box .member-box .member-list::-webkit-scrollbar {
  display: none;
}

.member_dialog .box .member-box .member-list .list {
  width: 100%;
  padding: 10px 15px;
  background: #fff;
  box-sizing: border-box;
  display: flex;
  position: relative;
}

.member_dialog .box .member-box .member-list .list.select {
  background: rgb(217, 235, 255);
}

.member_dialog .box .member-box .member-list .list .head {
  width: 45px;
  height: 45px;
}

.member_dialog .box .member-box .member-list .list .head img {
  width: 100%;
  height: 100%;
}

.member_dialog .box .member-box .member-list .list .info {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  margin-left: 5px;
  flex: 1;
}

.member_dialog .box .member-box .member-list .list .info .bm {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.member_dialog .box .member-box .member-list .list .checked {
  position: absolute;
  top: 10px;
  right: 15px;
}

.member_dialog .box .chat-box {
  flex: 1;
  border: 1px solid rgb(229, 229, 229);
}

.member_dialog .box .chat-box .top {
  width: 100%;
  padding: 10px;
  background: rgb(217, 235, 255);
  box-sizing: border-box;
}

.member_dialog .box .chat-box .top .title {
  font-weight: bold;
  color: rgb(56, 56, 56);
}

.member_dialog .box .chat-box .list {
  width: 100%;
  padding: 10px 15px;
  background: #fff;
  box-sizing: border-box;
  display: flex;
  position: relative;
}

.member_dialog .box .chat-box .list.select {
  background: rgb(217, 235, 255);
}

.member_dialog .box .chat-box .list .head {
  width: 45px;
  height: 45px;
}

.member_dialog .box .chat-box .list .head img {
  width: 100%;
  height: 100%;
}

.member_dialog .box .chat-box .list .info {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  margin-left: 5px;
}

.member_dialog .box .chat-box .list .info .name {
  font-size: 16px;
}

.member_dialog .box .chat-box .list .info .xx {
  font-size: 12px;
  color: #888;
}

.member_dialog .box .chat-box .list .right {
  position: absolute;
  top: 10px;
  right: 15px;
}

.member_dialog .box .chat-box .list .right .time {
  font-size: 12px;
  color: #888;
  margin-right: 10px;
}

.clean_box_dialog .box {
  padding: 0 30px;
  display: flex;
  align-items: center;
}

.clean_box_dialog .box .text-box {
  margin-left: 10px;
}

.clean_box_dialog .box .text-box>p {
  font-size: 16px;
  margin-bottom: 10px;
}

.clean_box_dialog .box1 {
  display: flex;
  flex-direction: column;
  padding: 20px 0;
}

.clean_box_dialog .box1 .progress {
  width: 600px;
}

/deep/ .clean_box_dialog .box1 .progress .el-progress__text {
  font-size: 20px !important;
}

.clean_box_dialog .box1 .jd {
  margin-top: 25px;
}

.clean_box_dialog .box1 .jd .blue {
  font-size: 12px;
  color: rgb(255, 141, 26);
  margin-left: 5px;
}


/deep/ .el-tabs__item {
  width: auto;
}

.lxr-list {
  overflow: hidden;
  overflow-y: auto;
  height: 292px;
}

.lxr-list::-webkit-scrollbar {
  display: none;
}

.configured-setup {
  background: #fff;
  padding: 20px;
  margin-top: 10px;
}

.configured-setup .box {
  margin-bottom: 10px;
}

.configured-setup .box .title {
  font-size: 18px;
  font-weight: 600;
  color: #222;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  position: relative;
}

.configured-setup .box .title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60px;
  height: 2px;
  background: var(--themeColors);
}

.configured-setup .box .tips-p {
  font-size: 14px;
  color: rgba(0, 0, 0, .85);
  padding: 10px 26px;
  background: #f0f8ff;
  border-radius: 4px;
  margin-top: 15px;
  margin-bottom: 10px;
  position: relative;
}

.configured-setup .box .tips-p::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translate(0, -50%);
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--themeColors);
}

.configured-setup .box .tips-p .blue-txt {
  color: var(--themeColors);
}

.configured-setup .box .tips-p .bold-txt {
  font-weight: bold;
}

.configured-setup .box .img {
  width: 800px;
}

.configured-setup .box .tips-p1 {
  color: rgba(0, 0, 0, .65);
  font-size: 14px;
  margin-bottom: 10px;
}

.configured-setup .box .tips-p1 .bold-txt {
  font-weight: bold;
}

.configured-setup .box .tips-p1 .red-txt {
  color: red;
  font-weight: bold;
}

.configured-setup .box .copy-box {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.configured-setup .box .copy-box .text-box {
  background: #f8f8f8;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, .15);
  padding: 10px;
  margin: 0 16px 0 0;
  white-space: pre;
  color: rgba(0, 0, 0, .65);
  font-size: 14px;
  max-width: 600px;
  display: block;
  white-space: normal;
}

.configured-setup .box .copy-box .copy-btn {
  font-size: 14px;
  cursor: pointer;
  color: var(--themeColors);
}

.configured-setup .box .warning {
  font-size: 14px;
  color: #f5222d;
  background: #fff5f5;
  padding: 5px;
  margin-top: 15px;
}

.configured-setup .box .input-box {
  display: flex;
  align-items: center;
}

.configured-setup .submit {
  height: 32px;
  padding: 0 15px;
  border: none;
  color: #fff;
  background: var(--themeColors);
}

.configured-setup .submit:hover {
  background: var(--themeColorsHover);
}

.input_w500 {
  width: 500px;
}</style>